<!--
 * @Author: tiandi
 * @Date: 2022-01-19 16:01:07
 * @LastEditTime: 2022-04-06 13:58:21
 * @LastEditors: Please set LastEditors
 * @Description: 工作台检查整改页面
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/index.vue
-->
<template>
  <section>
    <div
      slot="funBtn"
      class="flex mt-10 ml-10"
      :class="xfwdList.length > 1 ? 'tab-btn' : ''"
    >
      <w-button v-if="isOpenMulti" size="small" @click="mulZG()">
        批量整改
      </w-button>
    </div>
    <w-table
      ref="singleSelect"
      v-win-loading="loading"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
      class="mt-8"
      stripe
      :height="tableHeight"
      :span-method="mergeSpanMethod"
      @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange"
    >
      <w-table-column
        v-if="isOpenMulti"
        type="selection"
        align="center"
        width="50"
        :selectable="selected"
      />
      <template v-for="(item, index) in tableColumns">
        <w-table-column
          v-if="item.key == 'ZGZT'"
          :key="index"
          :label="item.name"
          :prop="item.key"
          :width="item.width"
          :min-width="item.minWidth"
          :align="item.align"
        >
          <template slot-scope="scope">
            <span>
              <span
                v-if="scope.row.XFZT == '1'"
                type="info"
                :plain="false"
                size="mini"
                >无需整改
              </span>
              <w-tag
                v-else-if="scope.row.ZGZT == 0"
                type="warning"
                :plain="false"
                size="small"
                >待整改
              </w-tag>
              <w-tag
                v-else-if="scope.row.ZGZT == 1"
                type="info"
                :plain="false"
                size="small"
                >整改中
              </w-tag>
              <w-tag
                v-else
                type="success"
                :plain="false"
                style="background-color: #5eb95e"
                size="small"
                >{{ scope.row.ZGZT == 2 ? '待评价' : '已评价' }}
              </w-tag>
            </span>
          </template>
        </w-table-column>
        <w-table-column
          v-else-if="item.type != 'selection'"
          :key="index + '_'"
          :prop="item.key"
          :label="item.name"
          :width="item.width"
          :align="item.align"
          :min-width="item.minWidth"
        >
        </w-table-column>
      </template>
      <w-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <template v-if="scope.row.XFZT == '0'">
            <!-- 状态 0待整改 1整改中 2待评价 3已评价-->
            <w-button
              v-if="scope.row.SFDJ == 1"
              type="text"
              :disabled="!scope.row.isCanSQ"
              class="red-botton"
              @click="toSQ(scope.row)"
            >
              整改申请
            </w-button>
            <w-button
              v-else
              type="text"
              :disabled="scope.row.ZGZT > 1"
              @click="toDetail(scope.row, 0)"
            >
              整改
            </w-button>
            <w-button
              type="text"
              :disabled="scope.row.ZGZT != 2"
              @click="rollBack(scope.row)"
            >
              撤销
            </w-button>
            <w-button
              v-if="needZP"
              type="text"
              :disabled="scope.row.ZGZT == 3 || scope.row.ZGZT == 0"
              @click="toDetail(scope.row, 1)"
            >
              自评
            </w-button>
          </template>
          <template v-else>
            <w-status type="error" common size="small">及时整改</w-status>
          </template>
        </template>
      </w-table-column>
    </w-table>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { pageSizes } from '@/common/settings/pageSettings'
import { DownFile } from '@/common/utils/download'
import QcRectificationDetail from '@/apps/modules/qc-rectification/analyse/_components/QcRectificationDetail.vue'
import { toArray, objectSpanMethod } from '@/common/utils/table.common.js'
import ApplyDialog from '@/common/components/Dialog/ApplyDialog.vue'

export default {
  name: 'workBenchZG',
  components: {},
  props: {
    cfxh: {
      type: Number,
      default: () => 0
    },
    zkjb: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      UserInfo: {},
      wdType: '20',
      pageSizes: pageSizes,
      PageSize: 20,
      PageIndex: 1,
      tableData: [],
      tableColumns: [
        { name: '整改状态', key: 'ZGZT', align: 'left', width: '100' },
        { name: '质控级别', key: 'ZKJBMC', align: 'left', width: '80' },
        { name: '受检科室', key: 'JCKSMC', align: 'left', width: '80' },
        { name: '督查时间', key: 'JCSJ', align: 'left', width: '80' },
        { name: '检查表单', key: 'BDMC', align: 'left', width: '80' },
        { name: '检查项目', key: 'XMMC', align: 'left', minWidth: '220' },
        { name: '质量标准', key: 'BZMC', align: 'left', minWidth: '220' },
        { name: '扣分标准', key: 'KFMC', align: 'left', minWidth: '220' },
        { name: '扣分原因', key: 'JCKFYY', align: 'left', minWidth: '220' },
        { name: '扣分', key: 'KFFZ', align: 'right', width: '80' },
        { name: '被查人', key: 'BJCZMC', align: 'left', width: '80' },
        { name: '责任人', key: 'ZRRMC', align: 'left', width: '80' },
        { name: '备注', key: 'MEMO', align: 'left', width: '160' },
        { name: '整改要点', key: 'ZGYD', align: 'left', width: '160' },
        //{ name: '状态', key: 'ZGZT', align: 'center', width: '120' },
        { name: '原因分析', key: 'YYFX', align: 'left', width: '120' },
        { name: '整改措施', key: 'ZGCS', align: 'left', width: '160' },
        { name: '整改人', key: 'ZGR_MC', align: 'left', width: '120' },
        { name: '整改时间', key: 'ZGSJ', align: 'left', width: '120' }
      ],
      defaultColumns: [], //用作保存原始列，方便切换tab
      currentRow: null,
      listQuery: {
        PageIndex: 1,
        PageSize: 15,
        total: 0,
        StartTime: '',
        EndTime: '',
        Zkjb: '',
        Jcfw: '',
        Bddms: '',
        XMWD: '20'
      },
      searchKeyInfo: {
        name: '试卷名/创建人', // searchKey-名称
        onlySearch: true
      },
      isOnlyMe: false,
      isShowOnlyMe: false, // 1100参数如果开启就只能看自己的检查，这时候就没有这个开关的必要了
      xfwdList: [{ XFWD: 20, XFWDMC: '质量标准' }],
      loading: false,
      isOpenMulti: true, //是否开启批量整改
      status1095: '0',
      selectObj: [],
      dataArr1: [[]], //用于合并列
      rowSpanArr1: [[]], //用于合并列
      mergeColumn: [
        { colmunIndex: 0, condition: ['PLFXDM'] },
        { colmunIndex: 1, condition: ['PLFXDM'] },
        { colmunIndex: 2, condition: ['PLFXDM'] },
        { colmunIndex: 3, condition: ['PLFXDM'] },
        { colmunIndex: 4, condition: ['PLFXDM'] },
        { colmunIndex: 5, condition: ['PLFXDM'] },
        { colmunIndex: 6, condition: ['PLFXDM'] }
      ],
      needZP: false, //是否需要自评
      tableHeight: 'calc(100vh - 100px)',
      xfwd: 20
    }
  },
  created() {
    this.UserInfo = this.$store.state.user.loginUserInfo
    this.defaultColumns = this.tableColumns
    this.getXtmj()
    this.getNeedZP()
    this.GetSxkzList()
  },
  mounted() {
    this.GetZGList()
  },
  methods: {
    GetSxkzList() {
      this.$requestApi('GetSxkzList', {}).then((res) => {
        if (res.success) {
          this.applyData = res.data.DataList.find((i) => i.CJDM == 'JCWTZG')
        } else {
          this.$msg(res.message)
        }
      })
    },
    selected(row, index) {
      if (row.XFZT == '1' || row.ZGZT >= 2) {
        return false
      } else {
        return true
      }
    },
    // 查询是否需要自评
    getNeedZP() {
      let that = this
      this.$requestApi('GetXTMJList', { Mjdm: '1098' }).then((res) => {
        if (res.data) {
          if (res.data && res.data.length > 0) {
            that.needZP = res.data[0].JLZT == '1'
          }
        }
      })
    },
    getXtmj() {
      let that = this
      that
        .$requestApi('GetXTMJList', { Mjdm: '1095,1100,1193' })
        .then((res) => {
          if (res.success) {
            that.status1095 = res.data.find((m) => m.MJDM == 1095).JLZT
            if (that.status1095 == '0') {
              that.isOpenMulti = false
            }
            if (that.status1095 == '1') {
              that.isOpenMulti = true
            }

            if (
              that.status1095 == '2' &&
              (this.zkjb == 1001 || this.zkjb == 1002)
            ) {
              that.isOpenMulti = false
            } else {
              this.isOpenMulti = true
            }
            that.isShowOnlyMe = res.data.find((m) => m.MJDM == 1100).JLZT != '1'
            that.xfwd = res.data.find((m) => m.MJDM == 1193).JLZT || 20
            that.toggleShow()
          }
        })
    },
    toggleShow() {
      switch (this.xfwd) {
        case '1': // 扣分标准，显示全部
          break
        case '2':
          this.tableColumns.splice(7, 1)
          break
        case '3':
          this.tableColumns.splice(6, 2)
          break
        case '4':
          this.tableColumns.splice(5, 3)
          break
        default:
          break
      }
    },
    handleCurrentChange(val) {
      this.currentRow = val
    },
    handleSelectionChange(val) {
      this.selectObj = []
      let that = this
      // 处理合并列后的选择
      val.forEach((item) => {
        if (item.PLFXDM) {
          that.tableData.forEach((n) => {
            if (n.PLFXDM == item.PLFXDM) {
              this.selectObj.push(n)
            }
          })
        } else if (item.FXXH) {
          that.tableData.forEach((n) => {
            if (n.FXXH == item.FXXH) {
              this.selectObj.push(n)
            }
          })
        } else {
          this.selectObj.push(item)
        }
      })
    },

    //获取整改列表数据
    GetZGList() {
      let obj = {
        PageIndex: 1,
        PageSize: 999,
        CFXH: this.cfxh,
        StartTime: '2000-01-01',
        EndTime: '2120-01-01', //时间取一个比较大的范围
        isOnlyMe: this.isOnlyMe
      }
      const that = this
      that.loading = true
      this.$requestApi('GetZGList', obj)
        .then((res) => {
          that.loading = false
          if (res.success) {
            that.tableloading = false
            that.tableData = res.data
            that.listQuery.total = res.total
            that.dataArr1 = toArray(res.data, that.tableColumns, 'key', true)
            that.rowSpanArr1 = that.getRowSpanForCondition(
              res.data,
              that.dataArr1,
              that.mergeColumn
            )
            that.$nextTick(() => {
              if (that.$refs.singleSelect.bodyWrapper) {
                that.$refs.singleSelect.bodyWrapper.scrollTop = 0
              }
              that.$refs.singleSelect.doLayout()
            })
          }
        })
        .catch((error) => {
          // that.$msg(error)
        })
    },

    // 批量整改
    mulZG() {
      if (this.selectObj.length == 0) {
        this.$msg('请选择数据!')
        return
      }
      if (this.selectObj.some((m) => m.SFDJ === 1)) {
        this.$msg('需要申请整改的数据不能进行批量整改!')
        return
      }
      if (this.selectObj.some((m) => m.ZGZT != 0 && m.ZGZT != 1)) {
        this.$msg('已整改的数据不能再进行整改!')
        return
      }

      let wtxhs = this.selectObj.map((m) => m.WTXH).join(',')
      let _sef = this
      let width = window.innerWidth * 0.7
      let height = window.innerHeight * 0.7
      this.$dlg.modal(QcRectificationDetail, {
        title: '整改评价',
        width: width,
        height: height,
        params: {
          wtxhs: wtxhs
        },
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.GetZGList()
          }
        },
        cancelCallback: () => {}
      })
    },
    // 导出
    exportFile(type) {
      let obj = {
        UserId: this.UserInfo.UserId,
        PageIndex: this.listQuery.PageIndex,
        PageSize: this.listQuery.PageSize,
        Zkjb: this.listQuery.Zkjb,
        StartTime: this.listQuery.StartTime,
        EndTime: this.listQuery.EndTime,
        Bddms: this.listQuery.Bddms,
        Jcfw: this.listQuery.Jcfw,
        ZGZT: this.listQuery.ZGZT,
        XFWD: this.listQuery.XFWD,
        isOnlyMe: this.isOnlyMe,
        ExportColumns: JSON.stringify(this.tableColumns),
        FileType: type // PDF/EXCEL
      }
      DownFile('NQCS/Download?act=ExportSJJCZG', obj)
    },
    toDetail(row, type) {
      let _sef = this
      let width = window.innerWidth * 0.7
      let height = window.innerHeight * 0.7
      this.$dlg.modal(QcRectificationDetail, {
        title: '整改评价',
        width: width,
        height: height,
        params: {
          wtxhs: row.WTXH || '',
          plfxdm: row.PLFXDM || '',
          fxxh: row.FXXH || '',
          type: type
        },
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.GetZGList()
          }
        },
        cancelCallback: () => {}
      })
    },
    toSQ(row) {
      let _sef = this
      let width = window.innerWidth * 0.5
      let height = window.innerHeight * 0.6
      let zkjbTemp =
        row.ZKJB == 1001
          ? '三级质控'
          : row.ZKJB == 1002
          ? '二级质控'
          : '一级质控'
      let params = {
        dataList: this.applyData,
        row,
        sqnr: `【${zkjbTemp}】【${row.BDMC || ''}】 【${row.JCKSMC || ''}】 【${
          row.JCZ || ''
        }】 ${this.applyData.CJMC}操作`
      }

      this.$dlg.modal(ApplyDialog, {
        title: `超期操作申请`,
        width: width,
        height: height,
        params,
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.GetZGList()
          }
        },
        cancelCallback: () => {
          this.GetZGList()
        }
      })
    },
    rollBack(row) {
      let that = this
      this.$Confirm('是否撤销整改', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          this.$requestApi('RollBackZG', {
            plfxdm: row.PLFXDM,
            fxxh: row.FXXH,
            wtxh: row.WTXH
          }).then((res) => {
            if (res.success) {
              that.$msg('撤销成功！', 'success')
              that.GetZGList()
            }
          })
        })
        .catch(() => {})
    },
    getRowSpanForCondition(data, dataArr, conditions) {
      var rowSpanArr = [[]]
      let columns = dataArr[0].length || 0
      //用于记录每列的计算行
      let rowposition = Array(columns).fill(0)
      //循环每一行数据
      dataArr.forEach((item, row) => {
        //初始化每行每列
        rowSpanArr[row] = Array(columns).fill(1)
        if (row > 0) {
          let over = false //判断当前行是否重新开始合并
          //循环当前行的每一列
          for (let column = 0; column < dataArr[row].length; column++) {
            let flag = conditions.find((m) => {
              return m.colmunIndex == column
            })
            let isMerge = true
            if (flag) {
              //根据条件进行合并
              flag.condition.forEach((x) => {
                let current = data[row][x] || ''
                let last = data[row - 1][x] || ''
                // 当plfxdm为空时不要合并
                if (current != last || (data[row]['PLFXDM'] || '') == '') {
                  isMerge = false
                }
              })
            }
            // 只根据本列进行合并
            if (isMerge && dataArr[row][column] == dataArr[row - 1][column]) {
              if (over) {
                rowposition[column] = row
              } else {
                rowSpanArr[rowposition[column]][column] += 1
                rowSpanArr[row][column] = 0
              }
            } else {
              rowposition[column] = row
              over = true
            }
          }
        }
      })
      return rowSpanArr
    },
    mergeSpanMethod({ row, column, rowIndex, columnIndex }) {
      let mergeArr = this.mergeColumn.map((m) => {
        return m.colmunIndex
      })
      return this.objectSpanMethod(
        { row, column, rowIndex, columnIndex },
        this.rowSpanArr1,
        mergeArr
      )
    },
    objectSpanMethod(
      { row, column, rowIndex, columnIndex },
      rowSpanArr,
      columnArr
    ) {
      // 只合并区域位置
      row
      column
      //   console.log(row, column)
      if (columnArr.some((m) => m == columnIndex)) {
        const _row = rowSpanArr[rowIndex][columnIndex]
        return {
          rowspan: _row, //行
          colspan: 1 //列
        }
      }
      // 合并固定列有问题（注释）
      // else if (columnIndex == 16) {
      //   //操作列和第一列的选择框相同
      //   const _row = rowSpanArr[0][columnIndex]
      //   return {
      //     rowspan: _row, //行
      //     colspan: 1 //列
      //   }
      // }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.option-zoom {
  margin-top: 16px;
  text-align: right;
}
.option-zoom .w-button + .w-button {
  margin-left: 16px;
}
.table-container {
  background-color: white;
}
.tool-container {
  margin-top: 6px;
  margin-bottom: 6px;
}
.search-container {
  background-color: white;
  padding: 10px;
}
/deep/ .wn-table-template__funBtn {
  position: relative;
}
/deep/ .w-table__fixed-body-wrapper {
  padding-bottom: 10px;
}
.tab-btn {
  position: absolute;
  right: 10px;
  top: -2px;
  z-index: 100;
}
</style>
